import { render, staticRenderFns } from "./PaymentDashboard.vue?vue&type=template&id=405092e4&scoped=true"
import script from "./PaymentDashboard.vue?vue&type=script&lang=js"
export * from "./PaymentDashboard.vue?vue&type=script&lang=js"
import style0 from "./PaymentDashboard.vue?vue&type=style&index=0&id=405092e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405092e4",
  null
  
)

export default component.exports